var _rect, _path, _path2, _path3, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKyCiconsPan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4.78516,
    width: 30,
    height: 23.5714,
    rx: 2.14286,
    fill: "#74A7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1484 16.5808C17.1484 15.9833 17.6327 15.499 18.2302 15.499H25.5875C26.1852 15.499 26.6696 15.9833 26.6696 16.5808V23.9381C26.6696 24.5358 26.1852 25.0202 25.5875 25.0202H18.2302C17.6327 25.0202 17.1484 24.5358 17.1484 23.9381V16.5808Z",
    fill: "#4083F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1289 17.0605H21.4235L20.7182 17.3629L20.3152 17.9675L20.1138 18.6726V19.7811L20.2145 20.5871L20.6174 21.1915L21.0205 21.4939V21.8969L20.416 22.4007L19.5092 22.8037L19.0053 23.106L18.7031 23.8113V24.8189H25.1515L25.2523 24.315L25.0508 23.6097L24.8492 23.106L24.2447 22.7029L23.338 22.3L22.935 21.9976V21.5946L23.1363 21.2924L23.5394 20.5871L23.741 19.8818L23.8418 18.8743L23.338 17.6651L22.7334 17.1614L22.1289 17.0605Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9043 18.85C19.9043 17.7157 20.8093 16.7964 21.9257 16.7964C23.0422 16.7964 23.9471 17.7158 23.9471 18.85V19.894C23.9471 20.6137 23.5825 21.2468 23.0316 21.6133C23.0457 21.7696 23.0919 21.8804 23.154 21.9652C23.3018 22.1677 23.5679 22.2682 23.9294 22.3954L23.9447 22.4007C24.2455 22.5064 24.6005 22.6313 24.8752 22.8842C25.167 23.1526 25.3515 23.5464 25.3515 24.1506V25.0191H18.5V24.1506C18.5 23.5464 18.6846 23.1526 18.9762 22.8842C19.2511 22.6313 19.6059 22.5064 19.9068 22.4007L19.9221 22.3954C20.2809 22.269 20.5458 22.1692 20.6943 21.9698L20.6976 21.9652C20.7595 21.8804 20.8058 21.7696 20.8198 21.6133C20.2689 21.2468 19.9043 20.6137 19.9043 19.894V18.85ZM18.8713 24.6162H24.9802V24.1506C24.9802 23.6341 24.8272 23.3488 24.6261 23.1636C24.4125 22.9672 24.1262 22.8638 23.8079 22.7517L23.7806 22.7421C23.4568 22.6285 23.0791 22.4957 22.8557 22.1901C22.7266 22.0132 22.656 21.7911 22.6559 21.5108V21.4018L22.7488 21.3474C23.2435 21.0575 23.5757 20.515 23.5757 19.894V18.85C23.5757 17.9241 22.837 17.1736 21.9257 17.1736C21.0143 17.1736 20.2756 17.9241 20.2756 18.85V19.894C20.2756 20.515 20.608 21.0574 21.1027 21.3474L21.1957 21.4018L21.1955 21.5108C21.1954 21.7105 21.1596 21.8806 21.0923 22.0259L21.1074 22.0371L20.9958 22.1901C20.7724 22.4957 20.3948 22.6285 20.0708 22.7421L20.0436 22.7517C19.7252 22.8638 19.439 22.9672 19.2255 23.1636C19.0241 23.3488 18.8713 23.6341 18.8713 24.1506V24.6162Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.21094,
    y: 10.1426,
    width: 16.0714,
    height: 1.60714,
    rx: 0.803571,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.21094,
    y: 14.4277,
    width: 8.57143,
    height: 1.60714,
    rx: 0.803571,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyCiconsPan);
export default __webpack_public_path__ + "static/media/KYCiconsPAN.e6f761888659ac05f877e4c031a5caca.svg";
export { ForwardRef as ReactComponent };